import * as React from 'react';
import Image from '@telia-front/image';
const SectionImage = (props) => {
    return (React.createElement("div", { className: "section__image-container" },
        React.createElement(Image, Object.assign({}, props, { className: "section__image" }))));
};
export { SectionImage as default };
